import { FilteredOrdersGridView } from '~/components/order/filtered/grid';
import { PageContainer } from '~/components/page-container';

export function FilteredOrders() {
	return (
		<PageContainer>
			<FilteredOrdersGridView />
		</PageContainer>
	);
}
